import React from 'react';
import {makeStyles} from 'tss-react/mui';
//MUI
import {lighten} from '@mui/material/styles';
import TabsMui from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import IconButton from '@mui/material/IconButton';
//ICONS
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
//DS
import {PtrnTabsProps} from './PtrnTabsTypes';

const useStyles = makeStyles()((theme) => ({
   tabs: {
      '& .MuiTabs-indicator': {
         display: 'flex',
         justifyContent: 'center',
         backgroundColor: 'transparent'
      },
      '& .MuiTabs-indicatorSpan': {
         width: 'calc(100% - 12px)',
         backgroundColor: theme.palette.primary.main
      }
   },
   tab: {
      textTransform: 'none',
      borderBottom: 'solid 1px',
      borderRadius: 5,
      '&.Mui-selected': {
         borderRadius: 10,
         backgroundColor: lighten(theme.palette.primary.light, 0.7)
      }
   }
}));

function TabLabel(props: {label: string; mostrarCerrar: boolean; onClose?: () => void}) {
   if (!props.mostrarCerrar) {
      return <>{props.label}</>;
   }
   return (
      <span>
         {props.label}
         <IconButton
            size="small"
            component="div"
            onClick={(e) => {
               e.stopPropagation(); // Prevent Tab selection when closing
               props.onClose?.();
            }}
         >
            <HighlightOffIcon />
         </IconButton>
      </span>
   );
}
const PtrnTabs = <T,>({
   selectedTab,
   onSelectedTabChange,
   tabList,
   genTabProps,
   mostrarCerrar,
   onCloseTab,
   ...other
}: PtrnTabsProps<T>) => {
   const {classes} = useStyles();

   function handleTabChange(event, tab) {
      if (event.target.tagName === 'SPAN' || event.target.tagName === 'BUTTON') {
         onSelectedTabChange(event, tab);
         return;
      }
   }
   const existeOnClose = Boolean(onCloseTab);
   const idCompPrefix = 'ptrn-tabs';
   return (
      <TabsMui
         variant="scrollable"
         scrollButtons="auto"
         {...other}
         id={idCompPrefix}
         className={classes.tabs}
         value={selectedTab}
         onChange={handleTabChange}
         TabIndicatorProps={{children: <span className="MuiTabs-indicatorSpan" />}}
      >
         {tabList.map((item, index) => {
            const {
               label,
               mostrarCerrar: mostrarCerrarCurrTab,
               ...tabProps
            } = genTabProps(item, index);
            let mostrarCerrarFinal = false;
            if (existeOnClose) {
               if (mostrarCerrarCurrTab != null) {
                  mostrarCerrarFinal = mostrarCerrarCurrTab;
               } else {
                  mostrarCerrarFinal = mostrarCerrar;
               }
            }

            return (
               <Tab
                  {...tabProps}
                  key={index}
                  label={
                     <TabLabel
                        label={label}
                        mostrarCerrar={mostrarCerrarFinal}
                        onClose={() => onCloseTab?.(index, item)}
                     />
                  }
                  className={classes.tab}
               />
            );
         })}
      </TabsMui>
   );
};
export default PtrnTabs;
